module.exports = __webpack_public_path__ + "img/image28.891e687d.png";